import { lazy } from 'react';

import { RouteGuard } from '@core/components/navigation/RouteGuard';
import DashboardLayout from '@core/layouts/DashboardLayout';
import { ROUTES } from '@core/utils/constants'; // Assuming ROUTES object exists and we can add to it

// Lazy load the main messaging page component
const Messaging = lazy(() => import('@messaging/index'));

const MessagingRouter = {
  element: (
    <RouteGuard mode="protected">
      <DashboardLayout />
    </RouteGuard>
  ),
  children: [
    { path: ROUTES.messaging.root, element: <Messaging /> },
    { path: ROUTES.messaging.contact, element: <Messaging /> },
  ],
};

export default MessagingRouter;
